<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                </div>
                <div class="modal-footer">
                    <button @click="handleConfirm" class="btn btn-md btn-primary me-2" type="button">
                        <span>{{ confirmText }}</span>
                    </button>
                    <button @click="hideModal" class="btn btn-md btn-outline-dark" type="button">
                        <span>{{ cancelText }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConfirmModal",

    props: {
        title: {
            type: String,
            Required: true,
        },
        confirmText: {
            type: String,
            Required: true,
        },
        confirmMethod: {
            type: Function,
            Required: true,
        },
        cancelText: {
            type: String,
            Required: true,
        },
        cancelMethod: {
            type: Function,
            Required: true,
        }
    },

    methods: {
        hideModal() {
            this.$emit('closeModal', false);
        },
        handleConfirm() {
            this.confirmMethod();
            this.$emit('closeModal', false);
            this.$emit('confirm');
        }
    }
}
</script>